import { render, staticRenderFns } from "./BatchUpdatePricesBtn.vue?vue&type=template&id=598ffe17&scoped=true&"
import script from "./BatchUpdatePricesBtn.vue?vue&type=script&lang=js&"
export * from "./BatchUpdatePricesBtn.vue?vue&type=script&lang=js&"
import style0 from "./BatchUpdatePricesBtn.vue?vue&type=style&index=0&id=598ffe17&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598ffe17",
  null
  
)

export default component.exports